import axios from '@/plugins/axios'
import { useAppStore } from '@/stores/app'

export type InterviewResponse = {
  data: Domain.Interviews.Resources.MyFJV2.InterviewResource;
}

export default {
  getUpcomingInterviews(studentId: number) {
    const appStore = useAppStore()

    return axios.get<Domain.Interviews.Resources.MyFJV2.InterviewSimpleResource[]>(`${appStore.daraApiBaseUrl}/students/${studentId}/upcoming-interviews`).then(({ data }) => {
      return data
    })
  },

  getInterview(interviewId: number) {
    const appStore = useAppStore()

    return axios.get<InterviewResponse, InterviewResponse>(`${appStore.daraApiBaseUrl}/upcoming-interviews/${interviewId}`)
  },
}
